import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { BiEditAlt } from "react-icons/bi";
import {
  CanAccess,
  AuthorizationList,
} from "../../../components/template/authorization/Authorization";

export const transactionTypeList = [
  {
    text: "Semua",
    count: 0,
    value: "semua",
    active: true,
  },
  {
    text: "Aktif",
    count: 0,
    value: "aktif",
    active: false,
  },
  {
    text: "Non Aktif",
    count: 0,
    value: "non_aktif",
    active: false,
  },
];

export const initFilterInput = {
  searchName: "",
  outlets: [],
  page: 1,
  pageSize: 10,
  transactionType: "semua",
  has_transaction: null,
  has_account: null,
  is_agent: null,
};

export const customerTypeOptions = [
  { value: "all", label: "Semua" },
  { value: "has_transaction", label: "Nasabah" },
  { value: "has_account", label: "Member" },
  { value: "is_agent", label: "Agen" },
];

export const renderColumns = (handleEdit = null, renderColumn = true) => {
  return [
    {
      dataIndex: "idCustomer",
      key: "idCustomer",
      title: "ID",
      width: 60,
    },
    {
      dataIndex: "customerName",
      key: "customerName",
      title: "Nama Nasabah",
      sorter: true,
    },
    {
      dataIndex: "phone",
      key: "phone",
      title: "No. Telepon",
    },

    {
      dataIndex: "status",
      key: "status",
      title: "Status Pinjaman",
      ellipsis: renderColumn ? false : true,
      ...(renderColumn && {
        render: (text) => (
          <div
            style={{
              color: text === "Aktif" ? "#56D453" : "#EF5353",
              textTransform: "capitalize",
            }}
          >
            {text}
          </div>
        ),
      }),
    },
    {
      dataIndex: "lastTransaction",
      key: "lastTransaction",
      title: "Transaksi Terakhir",
    },
    ...(renderColumn
      ? [
          {
            dataIndex: "action",
            key: "action",
            title: "Aksi",
            width: "10%",
            render: (_, record) => (
              <div
                style={{
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div className="mr-2" onClick={() => handleEdit(record)}>
                  <Button
                    className="btn-action"
                    style={{
                      borderColor: "#2C465C",
                      backgroundColor: "white",
                      color: "#2C465C",
                    }}
                  >
                    Ubah
                  </Button>
                </div>
                <Link
                  to={{
                    pathname: `/customer/${record.idCustomer}`,
                    state: {
                      status: record.status,
                    },
                  }}
                >
                  <Button variant="primary" className="btn-action btn-detail">
                    Detail
                  </Button>
                </Link>
              </div>
            ),
          },
        ]
      : []),
    // {
    //   dataIndex: "action",
    //   key: "action",
    //   title: "Aksi",
    //   width: "10%",
    //   render: (_, record) => (
    //     <div
    //       style={{ textAlign: "center", display: "flex", alignItems: "center" }}
    //     >
    //       <CanAccess
    //         role={AuthorizationList.view_customer}
    //         yes={
    //           <div className="mr-2" onClick={() => handleEdit(record)}>
    //             <Button
    //               className="btn-action"
    //               style={{
    //                 borderColor: "#2C465C",
    //                 backgroundColor: "white",
    //                 color: "#2C465C",
    //               }}
    //             >
    //               Ubah
    //             </Button>
    //           </div>
    //         }
    //       />
    //       <Link
    //         to={{
    //           pathname: `/customer/${record.idCustomer}`,
    //           state: {
    //             status: record.status,
    //           },
    //         }}
    //       >
    //         <Button variant="primary" className="btn-action btn-detail">
    //           Detail
    //         </Button>
    //       </Link>
    //     </div>
    //   ),
    // },
  ];
};
